import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between mt-0" }
const _hoisted_2 = {
  key: 0,
  d: "M7.615 11.795l4.59-4.59-1.41-1.41-6 6 6 6 1.41-1.41-4.59-4.59zm9.59 6v-12h-2v12h2z",
  "fill-rule": "evenodd",
  sandboxuid: "0"
}
const _hoisted_3 = {
  key: 1,
  d: "M6 7.41L10.438 12 6 16.59 7.363 18l5.802-6-5.802-6L6 7.41zM16.066 6H18v12h-1.934V6z",
  sandboxuid: "0"
}
const _hoisted_4 = { class: "d-grid gap-2" }
const _hoisted_5 = { style: {"font-size":"13px","color":"gray","font-weight":"bold"} }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = {
  version: "1.2",
  style: {"overflow":"visible","width":"299px","height":"1px","opacity":"1","mix-blend-mode":"normal"}
}
const _hoisted_9 = { class: "d-flex search-buttons" }

import { Ref, reactive, ref, computed, watch, onMounted } from 'vue'
import i18n from '@/lang/i18n'
import { saveDataToSessionStorage, loadDataFromSessionStorage, clearSessionStorage } from "@/services/functions/sessionStorage";

type formType = {
  search: string,
  status: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SerchForm',
  props: {
    isLoading: { type: Boolean }
  },
  emits: ['search', 'formchange', 'clear'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit
const hide: Ref<boolean> = ref(false)
const form: formType = reactive({
  search: "",
  status: 'only-active'
})

const title = computed(() => {
  return hide.value ? "" : i18n.global.t('pages.common.filter.title')
})

const searchAreaClass = computed(() => {
  return hide.value ? "search-area-hide p-4" : "search-area p-4"
})

onMounted(() => {
  const savedFormValues = loadDataFromSessionStorage('subManagementOfficeSearchForm');
  if (savedFormValues) {
    form.search = savedFormValues.search
    form.status = savedFormValues.status
  }
})

function clearForm () {
  form.search = ""
  form.status = 'only-active'
  clearSessionStorage('subManagementOfficeSearchForm')
  emits('clear')
}

function toggleSidebar () {
  hide.value = !hide.value
}

const changeSearchButton = computed(() => {
  return props.isLoading ? i18n.global.t('pages.common.button.loading') : i18n.global.t('pages.common.button.exec')
})

function handleClickSearch () {
  saveDataToSessionStorage('subManagementOfficeSearchForm', form)
  emits('search', form)
}

watch(form, () => { emits('formchange', form) })

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(searchAreaClass.value)
  }, [
    _createElementVNode("h4", _hoisted_1, [
      _createTextVNode(_toDisplayString(title.value) + " ", 1),
      (_openBlock(), _createElementBlock("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        fit: "",
        preserveAspectRatio: "xMidYMid meet",
        focusable: "false",
        sandboxuid: "0",
        onClick: toggleSidebar
      }, [
        (hide.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_2))
          : _createCommentVNode("", true),
        (!hide.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_3))
          : _createCommentVNode("", true)
      ]))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(`strpied-tabled-with-hover ${hide.value ? 'd-none' : '' }`)
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_text_field, {
          label: _unref(i18n).global.t('pages.subManagementOffice.companyName'),
          modelValue: form.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.search) = $event))
        }, null, 8, ["label", "modelValue"]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(i18n).global.t('pages.common.filter.status.title')), 1),
          _createVNode(_component_v_radio_group, {
            modelValue: form.status,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.status) = $event)),
            class: "radio-group-row"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_radio, {
                value: "only-active",
                label: _unref(i18n).global.t('pages.common.filter.status.onlyActive'),
                color: "blue"
              }, null, 8, ["label"]),
              _createVNode(_component_v_radio, {
                value: "all",
                label: _unref(i18n).global.t('pages.common.filter.status.all'),
                color: "blue"
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("defs", null, [
              _createElementVNode("path", {
                id: "path-1650848226989195",
                d: "M1126 703 C1126 703 1425 703 1425 703"
              })
            ], -1),
            _createElementVNode("g", { transform: "translate(-1126, -703)" }, [
              _createElementVNode("path", {
                style: {"stroke":"rgb(194, 186, 186)","stroke-width":"1","stroke-linecap":"butt","stroke-linejoin":"miter","fill":"none"},
                d: "M1126 703 C1126 703 1425 703 1425 703"
              })
            ], -1)
          ]))]))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_v_btn, {
            class: "ma-2 exec-btn",
            onClick: handleClickSearch,
            disabled: props.isLoading,
            style: _normalizeStyle({
              backgroundColor : props.isLoading ? '#B3B8BB' : ''
            })
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(changeSearchButton.value), 1)
            ]),
            _: 1
          }, 8, ["disabled", "style"]),
          _createVNode(_component_v_btn, {
            class: "ma-2 reset-btn",
            disabled: props.isLoading,
            onClick: clearForm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.reset')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ], 2)
  ], 2))
}
}

})